import initCtaSection from '../modules/cta';

const ctaSection = document.querySelectorAll('.cta');
if (ctaSection) {
    ctaSection.forEach(item => initCtaSection(item));
}